import React, { Component } from 'react';
import { withRouter } from 'react-router'
import Constants from './Constants.js';
import $ from 'jquery';
import moment from 'moment';
import '../../public/css/loading.css';

class RollingActiveUsers extends Component {

  constructor(props) {
    super(props);
    this.state = {
      weeks: []
    };
  } 
  
  componentWillMount() {
    const self = this;

    $.ajax({
      type: 'GET',
      url: `${Constants.API_HOST}metrics/rolling_active_users/`,
      contentType: 'application/json',
      dataType: "json",
      xhrFields: { withCredentials:true },
      success: function success(data) {
        self.setState({
          'weeks': data
        })

      },
      error: function error(data) {

      }
    });

  } 

  render() {
    if (this.state.weeks.length === 0) {
      return (
        <div className="loader">Loading...</div>
      )
    }

    return (
      <div>
        <h1>Active Users by ISO Week (Excluding Holidays)</h1>
        <p>
          This report excludes ISO weeks that have holidays in them.
        </p>

        <table className="table">
          <thead className="text-primary">
            <tr>
              <th>
                Start Date
              </th>
              <th>
                End Date
              </th>
              <th>
                Active Users Last 4 Weeks
              </th>
              <th>
                Total Teachers
              </th>
              <th>
                Retention
              </th>
              <th>
                ISO Week
              </th>
            </tr>
          </thead>
          <tbody>
          {
            this.state.weeks.map(function(week) {
              var retention = (week.active_users_last_4_weeks / week.total_teachers).toFixed(2)
              return (
                <tr key={week.start_date}>
                  <td>
                    {moment(week.start_date).format("MMM D, YYYY")}
                  </td>
                  <td>
                    {moment(week.end_date).format("MMM D, YYYY")}
                  </td> 
                  <td>
                    {week.active_users_last_4_weeks}
                  </td>
                  <td>
                    {week.total_teachers}
                  </td>
                  <td>
                    {retention}
                  </td>
                  <td>
                    {week.year}-{week.isoweeknum}
                  </td>
                </tr>
              )
            })
          }
          </tbody>

        </table>  

      </div>
    );
  }
}

export default withRouter(RollingActiveUsers);


// WEBPACK FOOTER //
// ./src/components/RollingActiveUsers.js